import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Toast from '../components/Toast';
import { ProductsProvider } from '../context/ProductsContext';
import styles from './AppLayout.module.css';

export default function AppLayout() {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!navOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [navOpen]);

  return (
    <ProductsProvider>
      <div className={styles.shell}>
        {navOpen && (
          <button
            type="button"
            className={styles.navScrim}
            aria-label="Close navigation"
            onClick={() => setNavOpen(false)}
          />
        )}
        <Sidebar mobileOpen={navOpen} onMobileClose={() => setNavOpen(false)} />
        <div className={styles.main}>
          <Topbar onMenuClick={() => setNavOpen(true)} />
          <div className={styles.content}>
            <Outlet />
          </div>
        </div>
        <Toast />
      </div>
    </ProductsProvider>
  );
}
